// extracted by mini-css-extract-plugin
export default {"main":"main_main__dIu9F","header":"main_header__tYPxv","content":"main_content__gyGxV","mobile":"main_mobile__fhtDf"};